import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { selectSkuCount, SkuSearchState } from '@emi/shared/state/sku-search';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
    selector: 'via-sku-count',
    templateUrl: './sku-count.component.html',
    styleUrls: ['./sku-count.component.scss'],
})
export class SkuCountComponent implements OnInit, OnDestroy {
    @Input()
    public displaySkuCount = true;

    @Input()
    public skuCount = 0;

    @Input()
    public maxDateRange = 0;

    @Input()
    public message = '';

    private skuCountSubscription: Subscription;

    constructor(private skuSearchStore: Store<SkuSearchState>) {}

    public ngOnInit(): void {
        this.skuCountSubscription = this.skuSearchStore.pipe(select(selectSkuCount)).subscribe((skuCount) => (this.skuCount = skuCount));
    }

    public showMaxDateRange(): boolean {
        return this.maxDateRange > 0 && this.maxDateRange !== Number.MAX_VALUE;
    }

    public showMessage(): boolean {
        return this.message !== '';
    }

    public ngOnDestroy(): void {
        this.skuCountSubscription.unsubscribe();
    }
}
